import axios from "axios";
import setAuthToken from "../utils/setAuthToken";
//import jwt from "jsonwebtoken";
import { getAccess } from "./accessAction";
import { mustChangePassword } from "../../passwordRules";


export function logUserPart1(data) {
	//return async function(dispatch) {
	return async dispatch => new Promise(async function(resolve, reject) {
		try {
			// dispatch({ type: "LOG_USER_START", payload: "" });
			// console.log('[INFO],logUserPart1,logUser,  data',{ data });

			const res = await axios.post("/auth/signin/part1", data);
			console.log('[INFO],logUserPart1,logUser,  info',{ res });

			const token = res.data.token; // PUBLIC TOKEN created with userID, email, private_token ...

			// Mot de passe temporaire (statut 3) : changement obligatoire avant le choix du compte ;
			// rien n'est écrit localement avant la reconnexion avec le nouveau mot de passe
			if (token && mustChangePassword(res.data.status)) {
				resolve({ mustChangePassword: true });
				return;
			}

			if (token) {
				localStorage.setItem("token_8000", token);
				localStorage.setItem("tokenMG", token);
				localStorage.setItem("userId", res.data.id);

				// localStorage.setItem('accessList_8000', JSON.stringify(accessList));
				setAuthToken(token, res.data.id); // set token in axios header requests

				//let currentUser = Object.assign({}, jwt.decode(token), res.data.user);
				// let currentUser = Object.assign({}, token, res.data);
				let currentUser = Object.assign({}, res.data);
				delete currentUser.API_token; // GENERATED BY API ON LOGIN

				// console.log("logUserPart1====================================");
				// console.log({ resdata: res.data });
				// console.log({ token, currentUser });
				// console.log("logUserPart1====================================");

				dispatch({ type: "SET_CURRENT_USER", payload: currentUser });
				dispatch({ type: "GET_USER_INFO", payload: res.data });	
				console.log("logUserPart1 >> ",currentUser)
				if (currentUser.role === 5){
					dispatch({ type: "UPDATE_CURRENT_USER_INFO", payload: currentUser.tokenAcess });
					dispatch(getAccess(currentUser.tokenAcess))
					resolve("ook");
					return;
				} else {
					resolve(currentUser.accountAccessList)	
					return;		
				}	
			}			
			console.log('[ERROR] authAction logUserPart1: ',res.data);
			resolve("Login Failed")
			return res;
		} catch (err) {
			console.log("[ERROR] login action,logUserPart1 ", err);
			// Échec renvoyé par /auth/signin/part1 : { error: { reason, message } }
			const failure = err && err.response && err.response.data && err.response.data.error;
			if (failure && failure.reason) {
				resolve({ error: failure });
				return;
			}
			resolve({ error: { reason: "server_error", message: "Le serveur ne répond pas, réessayez dans un instant." } });
		}
	});
}

export function logUser(data) {
	return async function(dispatch) {
		try {
			// dispatch({ type: "LOG_USER_START", payload: "" });
			console.log('[INFO],authAction,logUser,  data',{ data });

			const res = await axios.post("/auth/signin", data);
			console.log('[INFO],authAction,logUser,  info',{ res });
			
			//const token = res.data.token; // PUBLIC TOKEN created with userID, email, private_token ...
			if (res.data.tokenAcess) {

				console.log("===============tokenAcess=====================");
				console.log( res.data.tokenAcess );
				console.log("====================================");

				dispatch({ type: "UPDATE_CURRENT_USER_INFO", payload: {tokenAcess: res.data.tokenAcess, accountid: data.accountid} });
				dispatch(getAccess(res.data.tokenAcess))
							
				return "ok";
			}			
			console.log('[ERROR] authAction logUser: ',res.data.error);
			return res;
		} catch (err) {
			console.log("[ERROR] login action ", err);
			return err;
		}
	};
}


export function resetPwd(data) {
	return async function(dispatch) {
		try {
			// dispatch({ type: "LOG_USER_START", payload: "" });
			console.log('[INFO],authAction,resetPwd,  data',{ data });

			const res = await axios.post("/login/reset/pwd", data, {
				headers: {
					'Content-Type': 'application/json'
				}
			});
			console.log('[INFO],authAction,resetPwd,  info',{ res });
		
			if (res.data && res.data.error) {
				console.log('[ERROR] authAction resetPwd: ', res.data.error);
			}
			return res;
		} catch (err) {
			console.log("[ERROR] resetPwd action ", err);
			return err;
		}
	};
}

export function getUserInfo() {
	return async function(dispatch) {
		try {

			dispatch({ type: "GET_USER_INFO_START", payload: "" });
			let res = await axios.get("/users/userInfo");
			console.log({ res });

			if (res.data.error) {
				console.log("ERROR", res.data.error);
				dispatch(checkError(res.data.error))
				
			} else {
				dispatch({ type: "GET_USER_INFO", payload: res.data });
				dispatch({ type: "GET_USER_INFO_FULFILLED", payload: "" })
			}
		} catch (error) {
			console.log("ERROR", error);
			dispatch({ type: "GET_USER_INFO_ERROR", payload: error });

		}
	};
}

export function setCurrentUser(user) {
	return async function(dispatch) {
		dispatch({
			type: "SET_CURRENT_USER",
			payload: user
		})
		if (user.role !== -1) {
			dispatch(getUserInfo())
		}
	}
}


export function logout() {
	return dispatch => {
		localStorage.removeItem("token_8000");
		localStorage.removeItem("userInfo_8000");
		localStorage.removeItem("accessList_8000");
		localStorage.removeItem("tokenMG");

		setAuthToken(false);
		// dispatch(setCurrentUser({}));
		dispatch({
			type: "USER_LOGOUT",
			payload: {}
		})

	};
}
export function checkError(error) {
	return dispatch => {
		console.log('====================================');
		console.log({error});
		console.log('====================================');
		if( !error ){
			return
		}
		switch(error.statusCode){
			case 403: 
				dispatch(logout())
				break
			default:
				return

		}
	}
}
export function checkErrorData(res, type, dispatch) {
	let noError = false
	
	
	if( !res.data ){
		dispatch({
			type,
			payload: "pas de réponse"
		})
	} else if (res.data.error){

		if (res.data.error.statusCode === 403){
			dispatch(logout())
		} else {
			dispatch({
				type,
				payload: res.data.error.error
			})
		}
		
	} else {
		noError = true
	}
	return noError
	
}
export function checkErrorDataNull(res, type, dispatch) {
	let noError = false
	
	if( res.data && res.data.error){

		if (res.data.error.statusCode === 403){
			dispatch(logout())
		} else {
			dispatch({
				type,
				payload: res.data.error.error
			})
		}
		
	} else {
		noError = true
	}
	return noError
	
}


export function resetPassword(email) {
	return async function(dispatch) {
		try {
			let res = await axios.post("/auth/reset/password",{email});
			console.log({ res });

			// if (res.data.error) {
			// 	console.log("ERROR", res.data.error);
			// 	// dispatch(checkError(res.data.error))
				
			// } else {
			// 	dispatch({ type: "GET_USER_INFO", payload: res.data.user_info });
			// 	// dispatch({ type: "USER_INFO_FULFILLED", payload: "" })
			// }
		} catch (error) {
			console.log("ERROR", error);
		}
	};
}
export function resetPasswordUpdate(data) {
	return async function(dispatch) {
		try {
			let res = await axios.post("/auth/reset/password/update",{data});
			console.log({ res });

			// if (res.data.error) {
			// 	console.log("ERROR", res.data.error);
			// 	// dispatch(checkError(res.data.error))
				
			// } else {
			// 	dispatch({ type: "GET_USER_INFO", payload: res.data.user_info });
			// 	// dispatch({ type: "USER_INFO_FULFILLED", payload: "" })
			// }
		} catch (error) {
			console.log("ERROR", error);
		}
	};
}

export function fetchSociety() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SOCIETY_START", payload: "" })
            console.log("fetch Society START")
            const res = await axios.get('/auth/society/get')
            console.log({res});  
          
            if ( checkErrorData(res, "FETCH_SOCIETY_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_SOCIETY",
                    payload: res.data
                })
                dispatch({ type: "FETCH_SOCIETY_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] get society list ", err);
            dispatch({ type: "FETCH_SOCIETY_ERROR", payload: "" })
        }
    }
}
export function newSociety(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SOCIETY_START", payload: "" })
            console.log("new Society START", {data})
            const res = await axios.post('/auth/society/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_SOCIETY_ERROR", dispatch ) ) {
                let newData = Object.assign({}, res.data)
                dispatch({ type: "NEW_SOCIETY", payload: newData })
				dispatch({ type: "CREATE_SOCIETY_FULFILLED", payload: "" })
            }
            
        } catch(err) {
            console.log("[ERROR] new society ", err);
            dispatch({
                type: "CREATE_SOCIETY_ERROR",
                payload: err
            })
        }
    }
}

// Changement du mot de passe de l'utilisateur connecté (POST /login/change/pwd, session passport).
// En cas de succès le serveur détruit la session : l'appelant doit reconnecter ou déconnecter.
export async function changePassword(data) {
	try {
		const res = await axios.post("/login/change/pwd", data);
		if (res.data && res.data.success) {
			return { ok: true };
		}
		return { ok: false, error: (res.data && res.data.error) || "Erreur de modification du mot de passe." };
	} catch (err) {
		const error = err && err.response && err.response.data && err.response.data.error;
		return { ok: false, error: typeof error === "string" && error ? error : "Le serveur ne répond pas, réessayez dans un instant." };
	}
}
